import React, { useEffect } from "react";

import { styled } from "@mui/material/styles";
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);

  &:focus,
  &:hover,
  &:visited,
  &:link {
    text-decoration: none;
  }
`;

const DelendLink = (props) => {
  const location = useLocation();

  const checkActualRouteFullyMatchWithMenuPrefix = (location, to) => {
    return location.pathname.split("/").includes(to);
  };

  const isMenuActive = (to) => {
    if (location.pathname === to) return true;

    return checkActualRouteFullyMatchWithMenuPrefix(location, to);
  };

  useEffect(() => {}, [props.to]);

  return (
    <Tooltip  placement="right" title={props.showTooltip && props.text}>
          <StyledLink to={!props.disabled && props.to}>
      <ListItemButton
        disabled={props.disabled}
        style={{ backgroundColor: isMenuActive(props.to) && "#503DFC14", paddingLeft: 8 }}
      >
        <ListItemIcon sx={{ color: isMenuActive(props.to) && "#503DFC", minWidth: 42}}>
          {props.icon}
        </ListItemIcon>
        <ListItemText
          sx={{ color: isMenuActive(props.to) && "#503DFC"}}
          primary={props.text}
          primaryTypographyProps={{fontSize: '13px'}} 
        />
      </ListItemButton>
    </StyledLink>
    </Tooltip>

  );
};

export default DelendLink;
